import React from 'react';
import '../../../../../../../Stylesheets/Dashboard/Tabs/Materials/SmartSuggestions.css';

const SmartSuggestions = ({ suggestions, onRemove }) => {
  return (
    <div className="material-tab-box">
      <h4 className="material-tab-box-title">Smart Suggestions</h4>
      {suggestions.length === 0 ? (
        <p className="material-tab-empty-msg">No suggestions</p>
      ) : (
        suggestions.map((item, idx) => (
          <div className="material-tab-suggestion-item" key={idx}>
            <span className="material-tab-suggestion-line" />
            <p className="material-tab-suggestion-text">{item.text}</p>
            <button className="material-tab-close-btn" onClick={() => onRemove(idx)}>×</button>
          </div>
        ))
      )}
    </div>
  );
};

export default SmartSuggestions;
